import { Business, Person, Store } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Loading } from 'src/components/Loading';
import { SCRoutes } from 'src/config';
import { useDashboardOrganization } from '../hooks';

type Props = {
  testID?: string;
};

export const DashboardHome: React.FC<Props> = ({ testID = 'DashboardOrganizationHome' }) => {
  const { data, isLoading, error, fetchStates, connectedAgencies, totalAgenciesTransporters, totalAgenciesPartners } =
    useDashboardOrganization();

  const { t } = useTranslation();

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    <div className="min-h-screen bg-white flex justify-center align-center">{t(error.message)}</div>;
  }

  return (
    <div data-testid={testID} className="min-h-screen bg-primary">
      <div className=" min-h-screen py-4 px-6">
        <div className="text-3xl font-light text-center m-auto">{t('dashboard-home.welcome')}</div>

        <div className="mt-10 grid grid-cols-3 gap-6">
          <div className="shadow-lg rounded-lg bg-white text-black h-44 flex">
            <div className="p-6 flex flex-col justify-between ">
              <div className="text-md text-gray-500">
                <Business className="text-4xl color-primary  mx-2" />
                {t('dashboard-home.dashboard-organization')}
              </div>

              <div className=" font-light text-2xl text-gray-800 text-center">{data?.organization?.name}</div>
              <div
                className="text-md text-gray-500 font-light"
                dangerouslySetInnerHTML={{
                  __html: t('dashboard-home.dashboard-sold', {
                    amount: data?.organization.currentConsumptionAmount,
                  }),
                }}
              />
            </div>
          </div>
          <Link className="shadow-lg rounded-lg bg-white text-black h-44 flex" to={SCRoutes.dashboard.agencies.home}>
            <div className="p-6 flex flex-col justify-between">
              <div className="text-md text-gray-500">
                <Store className="text-4xl color-primary  mx-2" />
                {t('dashboard-home.dashboard-agencies')}
              </div>

              <div
                className="text-md text-gray-500 font-light"
                dangerouslySetInnerHTML={{
                  __html: t('dashboard-home.our-agencies', {
                    count: data?.agencies,
                  }),
                }}
              />

              <div>
                <span
                  className={`${
                    !!connectedAgencies?.length ? 'bg-green-500' : 'bg-red-500'
                  } mr-2 h-3 w-3 rounded-full inline-block`}
                ></span>
                <div
                  className="inline-block text-md text-gray-500 font-light"
                  dangerouslySetInnerHTML={{
                    __html: t('dashboard-home.connected-agencies', {
                      count: connectedAgencies?.length,
                    }),
                  }}
                />
              </div>

              <div
                className="text-md text-gray-500 font-light"
                dangerouslySetInnerHTML={{
                  __html: t('dashboard-home.partners-agencies', {
                    count: totalAgenciesPartners,
                  }),
                }}
              />
              <div
                className="text-md text-gray-500 font-light"
                dangerouslySetInnerHTML={{
                  __html: t('dashboard-home.partner-transporters-agencies', {
                    count: totalAgenciesTransporters,
                  }),
                }}
              />
            </div>
          </Link>
          <Link className="shadow-lg rounded-lg bg-white text-black h-44 flex" to={SCRoutes.dashboard.users.home}>
            <div className="p-6 flex-col flex justify-between">
              <div className="text-md text-gray-500">
                <Person className="text-4xl color-primary mx-2" />
                {t('dashboard-home.dashboard-users')}
              </div>

              <div
                className="text-md  text-gray-500 font-light"
                dangerouslySetInnerHTML={{
                  __html: t('dashboard-home.users', {
                    count: data?.users,
                  }),
                }}
              />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
